var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWritersproducers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "256px",
    width: "256px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-51.2 -51.2 614.40 614.40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -51.2,
    y: -51.2,
    width: 614.4,
    height: 614.4,
    rx: 0,
    fill: "#ffffff",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M397.907,484.519c-0.179-0.156-61.403-53.641-61.586-53.791l-56.498-49.361l77.772-67.95h-47.637L256,360.552 l-53.958-47.135h-47.637l77.772,67.95l-57.031,49.821l-61.053,53.332c-6.52,5.695-7.189,15.6-1.494,22.121 c5.693,6.497,15.564,7.199,22.12,1.494l56.863-49.674h128.836l56.863,49.674c6.555,5.704,16.427,5.004,22.12-1.494 C405.096,500.12,404.428,490.214,397.907,484.519z M227.464,427.112L256,402.181l28.536,24.931H227.464z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M429.265,140.957c-8.662,0-15.673,7.022-15.673,15.673v35.035h-10.658V15.673C402.933,7.022,395.912,0,387.26,0H124.74 c-8.652,0-15.673,7.022-15.673,15.673v175.992H98.408V156.63c0-8.652-7.011-15.673-15.673-15.673 c-8.652,0-15.673,7.022-15.673,15.673v109.767c0,8.662,7.022,15.673,15.673,15.673h346.53c8.652,0,15.674-7.011,15.674-15.673 V156.63C444.938,147.978,437.917,140.957,429.265,140.957z M231.831,65.128l13.96-2.017l6.238-12.57c1.62-3.26,6.322-3.26,7.941,0 l6.238,12.57l13.96,2.017c3.626,0.522,5.078,4.953,2.456,7.502l-10.104,9.78l2.382,13.814c0.627,3.615-3.197,6.322-6.416,4.639 L256,94.344l-12.487,6.52c-3.239,1.693-7.043-1.045-6.416-4.639l2.382-13.814l-10.104-9.78 C226.753,70.092,228.206,65.651,231.831,65.128z M371.586,191.666H140.413v-42.203h231.173V191.666z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritersproducers);
export default __webpack_public_path__ + "static/media/writersproducers.038e6e3c8475a42fe9918658da9d4484.svg";
export { ForwardRef as ReactComponent };